export const WEBSITE_MATCH_EXAMPLE = {
  businessType: 'HVAC contractors',
  filters: ['emergency service', '24/7 repair', 'same-day help'],
  matches: ['Mentions emergency repair', 'Mentions 24/7 service'],
} as const;
